// extracted by mini-css-extract-plugin
export default {"root":"PostcodePrompt-root","message":"PostcodePrompt-message"};